<template>
  <v-dialog
    max-width="800"
    v-model="show"
    @click:outside="$emit('close')"
    :fullscreen="$vuetify.breakpoint.mobile"
    scrollable
  >
    <v-card class="d-flex flex-column" style="height: 100vh;">
      <v-card-title>
        Valitse pelit
      </v-card-title>
      <div class="sticky-selector">
        <v-card-text>
          <v-autocomplete
            hide-details
            clearable
            :loading="loading_clubs"
            :items="clubs"
            v-model="club"
            label="Joukkue"
            item-text="club_name"
            item-value="id"
          ></v-autocomplete>
        </v-card-text>
      </div>
      <v-card-text class="flex-grow-1">
        <div
          v-for="video in filteredGames"
          :key="'cho' + video.id"
          class="mb-2"
        >
          <v-chip
            label
            style="cursor: pointer;"
            @click="handleClick(video)"
            :color="videoIsChosen(video.id) ? 'primary' : ''"
          >
            <v-img class="mx-2" height="20" width="20" :src="video.home_club_logo_url"></v-img>
            {{video.home_club_short_name}} - {{video.away_club_short_name}}
            <v-img class="mx-2" height="20" width="20" :src="video.away_club_logo_url"></v-img>
          </v-chip>
          {{ prettyDate(video) }}
        </div>
      </v-card-text>
      <v-card-title v-if="!filteredGames || !filteredGames.length">
        Ei pelejä
      </v-card-title>
      <v-divider></v-divider>
      <v-card-actions class="flex-wrap">
        <v-btn @click="clear()" class="mb-2">
          {{ $t('clear') }}
        </v-btn>
        <v-btn @click="chooseAll()" class="mb-2">
          {{ $t('choose_all') }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          @click="$emit('close')"
          class="mb-2"
        >
          Ok
          <v-chip
            small
            class="ml-2"
            style="cursor: pointer;"
          >{{value.length ? `${value.length} peliä` : 'Kaikki pelit'}}</v-chip>
          <v-icon class="ml-2">mdi-keyboard-return</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  props: ['show', 'value', 'getGames', 'leagueId'],
  shortcuts: {
    enter: function() {
      this.$emit('close')
      return !this.show
    }
  },
  created() {
    if(!this.clubs || !this.clubs.length) this.initClubs(this.leagueId)
    if((!this.games || !this.games.length) && this.getGames) {
      this.initGames({ leagueId: this.leagueId })
        .then(() => {
          // this.$nextTick(() => {
          //   this.chooseAll()
          // })
        })
        .catch(e => this.error(e))
    } else if(!this.videos || !this.videos.length) {
      this.initVideos()
        .then(() => {
          // this.$nextTick(() => {
          //   this.chooseAll()
          // })
        })
        .catch(e => this.error(e))
    }
  },
  data: () => ({
    club: null
  }),
  methods: {
    ...mapActions('admin', [
      'initGames',
      'initClubs'
    ]),
    ...mapActions('videos', [
      'initVideos'
    ]),
    ...mapActions('noti', [
      'error'
    ]),
    nLatest(n) {
      this.$emit('input', this.games.slice(0, n).map(t => t.id))
    },
    videoIsChosen(id) {
      if(!this.value) return false
      return this.value.includes(id)
    },
    handleClick(video) {
      const id = video.id;
      let val;
      if(this.videoIsChosen(id)) val = [...this.value].filter(t => t !== id)
      else val = [...this.value].concat(id)
      this.$emit('input', val)
    },
    chooseAll() {
      this.$emit('input', !this.getGames ? [...this.videos] : [...this.games])
    },
    clear() {
      this.$emit('input', [])
    },
    prettyDate(game) {
      const date = new Date(game.starttime_unix)
      return date.getDate() + '.' + (date.getMonth() + 1) + '.' + date.getFullYear()
    }
  },
  computed: {
    ...mapGetters('admin', [
      'games',
      'clubs',
      'loading_clubs'
    ]),
    ...mapGetters('videos', [
      'videos'
    ]),
    filteredGames() {
      if(!this.club) return this.games
      return this.games.filter(g => g.home_club_id === this.club || g.away_club_id === this.club)
    }
  }
}
</script>

<style scoped>
.sticky-selector {
  position: sticky;
  top: 0;
  z-index: 1;
  background: white;
  padding-top: 10px;
  padding-bottom: 10px;
}
.v-card-actions {
  padding: 8px 16px;
}
</style>